import React, { ReactNode, useEffect } from 'react'

import Button, { ButtonProps } from 'common/components/button'
import ButtonWithDropdown, {
  ButtonOptionsProps,
} from 'common/components/ButtonWithDropdown'
import {
  updateIntercomDefault,
  updateIntercomForBottomToolbar,
} from 'common/components/Intercom'

interface Props {
  shouldShowOnlyPrimary?: boolean
  cancelButton?: {
    isDisplayed: boolean
    onClick: () => void
  }
  saveButton?: {
    isDisplayed: boolean
    isDisabled: boolean
    onClick: () => void
    isLoading: boolean
  }
  nextButton: {
    isDisabled: boolean
    onClick?: () => void
    name: string
    icon?: ReactNode
    isLoading: boolean
    variant?: ButtonProps['variant']
    options?: ButtonOptionsProps[]
  }
  nextInfoMessage: React.ReactNode
}

const ActionBar = ({
  cancelButton,
  saveButton,
  nextButton,
  nextInfoMessage,
  shouldShowOnlyPrimary,
}: Props) => {
  useEffect(() => {
    updateIntercomForBottomToolbar()
    return () => updateIntercomDefault()
  }, [])
  return (
    <>
      <div
        className={`sticky bottom-0 pt-4 pb-4 pl-6
                    pr-6 bg-white flex justify-between shadow-top`}
      >
        <div>
          {!shouldShowOnlyPrimary && (
            <>
              {cancelButton?.isDisplayed && (
                <Button
                  data-cy="cancel-campaign-creation"
                  variant="danger"
                  className="mr-4 pointer-events-auto"
                  onClick={cancelButton.onClick}
                  ghost
                >
                  Cancel
                </Button>
              )}
              {saveButton?.isDisplayed && (
                <Button
                  data-cy="save-button"
                  variant="success"
                  ghost
                  loading={saveButton?.isLoading}
                  disabled={saveButton?.isDisabled}
                  onClick={saveButton?.onClick}
                >
                  Save
                </Button>
              )}
            </>
          )}
        </div>
        <div className="flex items-center">
          <span className="text-orange-400 mr-4 text-base font-medium">
            {nextInfoMessage}
          </span>
          {nextButton.options && nextButton.options.length > 0 ? (
            <ButtonWithDropdown
              data-cy="next-button"
              variant="primary"
              loading={nextButton.isLoading}
              disabled={nextButton.isDisabled}
              options={nextButton.options}
              className="hover:bg-orange-500"
            >
              {nextButton.name}
            </ButtonWithDropdown>
          ) : (
            <Button
              data-cy="next-button"
              size="large"
              variant={nextButton.variant || 'primary'}
              prefixIcon={nextButton.icon}
              loading={nextButton.isLoading}
              disabled={nextButton.isDisabled}
              onClick={nextButton.onClick}
            >
              {nextButton.name}
            </Button>
          )}
        </div>
      </div>
    </>
  )
}

export default ActionBar
